export default {
      id: "ic_hamburger_green-usage",
      viewBox: "0 0 48 48",
      url: "/" + "images/icons.3.109.2.svg#ic_hamburger_green-usage",
      toString: function () {
        return this.url;
      }
    }